<template>
    <div>
        <div class="container-flex">
            <LinceButton
                :theme="getViewByMode('uploaded')"
                :view="'square'"
                style="margin-left: 20px;"
                @click="onUploaded"
            >
                Добавлено ({{summaryUploaded}})
            </LinceButton>

            <LinceButton
                :theme="getViewByMode('withoutPrices')"
                :view="'square'"
                style="margin-left: 20px;"
                @click="onWithoutPrices"
            >
                Без цен ({{summaryWithoutPrices}})
            </LinceButton>

            <LinceButton
                :theme="getViewByMode('doubles')"
                :view="'square'"
                style="margin-left: 20px;"
                @click="onDoubles"
            >
                Дубли ({{summaryDoubles}})
            </LinceButton>

            <LinceButton
                :theme="getViewByMode('errors')"
                :view="'square'"
                style="margin-left: 20px;"
                @click="onErrors"
            >
                Ошибки ({{summaryErrors}})
            </LinceButton>
        </div>

        <AppTable
            primaryKey="id"
            :columns="columnsPrepared"
            :rows="bufferRows"
            class="cloud-import-log__table"
            @lazyload="onLazyload"
            @search="onSearch"
        >
            <template v-slot:tax="{row}">
                {{row.tax ? 'с НДС' : 'без НДС'}}
            </template>
            <template v-slot:light="{row}">
                {{row.light ? 'Да' : 'Нет'}}
            </template>
            <template v-slot:links="{row}">
                <div>
                    <a
                        v-if="row.image_src"
                        :href="row.image_src"
                        target="_blank"
                    >
                        Фото
                    </a>
                    <a
                        v-if="row.map_link"
                        :href="row.map_link"
                        target="_blank"
                    >
                        Карта
                    </a>
                </div>
            </template>
            <template v-slot:report="scopeData">
                <div
                    v-if="mode === 'uploaded'"
                    class="cloud-import-log__dates"
                >
                    <p
                        v-for="(price, index) in scopeData.row.prices"
                        :key="index"
                        :style="{color: '#' + getMonthColor(price)}"
                    >
                        {{getMonthLabel(price)}}
                    </p>
                </div>

                <div
                    v-if="mode === 'doubles'"
                    class="cloud-import-log__dates"
                >
                    Дубль строки '{{scopeData.row.double_row}}'
                </div>

                <div
                    v-if="mode === 'errors'"
                    class="cloud-import-log__errors"
                >
                    <div
                        v-for="(error, index) in scopeData.row.errors"
                        :key="index"
                    >
                        {{error}}
                    </div>
                </div>
            </template>
        </AppTable>
    </div>
</template>

<script>
import SchemeCloudImportLog from "@/schemes/SchemeCloudImportLog";
const {columns: schemeColumns = []} = SchemeCloudImportLog;


import AppTable from '@/components/Table2/Table.vue';
import UtilDate from "@/utils/UtilDate";

export default {
    name: "CloudImportLog",
    components: {
        
        AppTable
    },
    data: () => ({
        summaryUploaded: 0,
        summaryWithoutPrices: 0,
        summaryDoubles: 0,
        summaryErrors: 0,
        columns: schemeColumns,
        bufferRows: []
    }),
    props: {
        mode: {
            type: String,
            default: () => ('uploaded')
        },
        rows: {
            type: Array,
            default: () => ([])
        },
        isStaticSummary: {
            type: Boolean,
            default: false
        },
        summary: {
            type: Object,
            default: () => ({})
        },
        isSearch: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        columnsPrepared() {
            if(this.isSearch){
                return this.columns;
            }

            return this.columns.reduce((columns, column) => {
                column.canSearch = false
                return [...columns, column]
            }, []);
        }
    },
    watch: {
        rows() {
            this.createBuffer();
        },

        mode() {
            this.createBuffer();
        },

        summary(){
            this.appendSummary()
        }
    },
    mounted() {
        this.appendSummary()
        this.createBuffer();
    },
    methods: {
        appendSummary() {
            if(this.isStaticSummary){
                const {uploaded = 0, withoutPrices = 0, doubles = 0, errors = 0} = this.summary
                this.summaryUploaded = uploaded
                this.summaryWithoutPrices = withoutPrices
                this.summaryDoubles = doubles
                this.summaryErrors = errors
            }
        },

        onUploaded() {
            this.$emit('onChangeMode', 'uploaded');
        },

        onWithoutPrices() {
            this.$emit('onChangeMode', 'withoutPrices');
        },

        onDoubles() {
            this.$emit('onChangeMode', 'doubles');
        },

        onErrors() {
            this.$emit('onChangeMode', 'errors');
        },

        createBuffer() {
            if(!this.isStaticSummary){
                this.summaryUploaded = 0
                this.summaryWithoutPrices = 0
                this.summaryDoubles = 0
                this.summaryErrors = 0
            }

            this.bufferRows = this.rows.reduce((rows, row) => {
                const {errors = [], double_row: doubleRow = null, prices = {}} = row
                const isDouble = doubleRow !== null
                const isErrors = (errors ?? []).length > 0

                let isWithoutPrices = true;
                Object.values(prices ?? {}).forEach((price) => {
                    const {price: priceVal = null} = price
                    if(priceVal !== null && priceVal){
                        isWithoutPrices = false
                    }
                })

                const isUploaded = !isErrors && !isDouble && !isWithoutPrices;

                if(isUploaded && !this.isStaticSummary){
                    this.summaryUploaded++;
                }

                if(!isErrors && isDouble && !this.isStaticSummary){
                    this.summaryDoubles++;
                }

                if(isErrors && !this.isStaticSummary){
                    this.summaryErrors++;
                }

                if(!isErrors && isWithoutPrices && !this.isStaticSummary){
                    this.summaryWithoutPrices++;
                }

                switch (this.mode) {
                    case 'uploaded': {
                        if (isUploaded) {
                            rows.push(row);
                        }
                        break;
                    }
                    case 'withoutPrices': {
                        if (!isErrors && isWithoutPrices) {
                            rows.push(row);
                        }
                        break;
                    }
                    case 'doubles': {
                        if (!isErrors && doubleRow !== null) {
                            rows.push(row);
                        }
                        break;
                    }
                    case 'errors': {
                        if (isErrors) {
                            rows.push(row);
                        }
                        break;
                    }
                }

                return rows;
            }, [])
        },

        getViewByMode(mode) {
            return this.mode === mode ? 'third' : 'secondary';
        },

        getMonthLabel(price) {
            const {date = null} = price
            return UtilDate.getMonthsName(date)
        },

        getMonthColor(price) {
            const {action = null} = price
            switch (action) {
                case 'insert':
                    return '008e13'
                case 'update':
                    return 'f1c232'
                case 'delete':
                    return 'e06666'
            }
            return '000000'
        },

        onLazyload(){
            console.log("lazyload")
            this.$emit('onLazyload')
        },

        onSearch(value) {
            this.$emit('onSearch', value)
        },
    }
}
</script>

<style scoped lang="scss">
.cloud-import-log {
    &__table {
        width: 100%;
        height: auto;
        max-height: 100vh;
    }

    &__dates {
        display: flex;
        overflow-x: auto;
    }

    &__errors {
        display: block;
    }

    &__dates p{
        padding: 2px;
    }
}

.container-flex {
    display: flex;
    padding: 10px;

    .base-checkbox{
        margin: 5px;
    }
}
</style>
